<xemex-page-header
  [title]="packageName() || 'Service'"
  [subtitle]="locationStreet()"
  [breadcrumbs]="breadcrumbs()"
  [badges]="statusBadges()"
  [withBackground]="true"
  [icon]="'credit_card'"
>
</xemex-page-header>

<xemex-page-body>
  <xemex-card-grid>

    <xemex-card [title]="'services.detailCard.title' | translate">
      <div class="grid grid-cols-2 gap-4">
        <xemex-detail-field [label]="'services.columns.price' | translate">
          {{ formattedPrice() }}
        </xemex-detail-field>
        <xemex-detail-field [label]="'services.columns.term' | translate">
          {{ service()?.term ?? '—' }}
        </xemex-detail-field>
        <xemex-detail-field [label]="'services.columns.createdOn' | translate">
          {{ service()?.createdOn ? (service()!.createdOn | date: 'MMM d, yyyy') : '—' }}
        </xemex-detail-field>
        <xemex-detail-field [label]="'services.columns.activatedOn' | translate">
          {{ service()?.activatedOn ? (service()!.activatedOn | date: 'MMM d, yyyy') : '—' }}
        </xemex-detail-field>
      </div>
    </xemex-card>

    <xemex-card
      [title]="'services.locationCard.title' | translate"
      [actionLabel]="locationDetailRoute() ? 'More' : undefined"
      actionIcon="chevron_right"
      (action)="onLocationMore()"
    >
      <div class="flex flex-col gap-4">
        <xemex-detail-field [label]="'services.locationCard.address' | translate">
          {{ locationStreet() }}
        </xemex-detail-field>
        <xemex-detail-field [label]="'services.locationCard.postalCode' | translate">
          {{ locationDetail().locationPostalCode }}
        </xemex-detail-field>
        <xemex-detail-field [label]="'services.locationCard.city' | translate">
          {{ locationDetail().locationCity }}
        </xemex-detail-field>
      </div>
    </xemex-card>

  </xemex-card-grid>
</xemex-page-body>
